import {
  SeQuestionDto,
  useSendSeClarificationMessageAsSupplierMutation,
} from "../../../../../autogen/bff-api";
import { AttachmentDocumentOption } from "../../../../../common/components/communication/AttachmentPicker";
import { ClarificationReplyForm } from "../../../../../common/components/communication/ClarificationReplyForm";
import { ClarificationThread } from "../../../../../common/components/communication/ClarificationThread";
import { useMessageAttachments } from "../../../../../common/components/communication/useMessageAttachments";
import { useApiError } from "../../../../../common/errors/useApiError";

export const SupplierClarificationThread = ({
  clarification,
  requestDocuments,
  offerDocuments,
  designContest = false,
}: {
  clarification: SeQuestionDto;
  requestDocuments: AttachmentDocumentOption[];
  offerDocuments?: AttachmentDocumentOption[];
  designContest?: boolean;
}) => {
  const displayer = useApiError();
  const eventId = clarification.eventId;
  const [sendMessage, { isLoading }] = useSendSeClarificationMessageAsSupplierMutation();
  const attachments = useMessageAttachments({
    eventId,
    uploadEntityType: "SeV2QuestionAttachment",
    pollRole: "portal",
    questionId: clarification.id,
  });

  const handleSend = async (content: string) => {
    try {
      await sendMessage({
        eventId,
        questionId: clarification.id,
        createSeQuestionMessageRequest: { content, attachments: attachments.toInputs() },
      }).unwrap();
      return true;
    } catch (error) {
      displayer.trigger(error);
      return false;
    }
  };

  return (
    <ClarificationThread
      question={clarification}
      viewerIsBuyer={false}
      footer={
        <ClarificationReplyForm
          attachments={attachments}
          requestDocuments={requestDocuments}
          offerDocuments={offerDocuments}
          designContest={designContest}
          isSending={isLoading}
          onSend={handleSend}
        />
      }
    />
  );
};
